export default {
  id: 'expenses',
  title: 'Expense Reports',
  category: 'Employee',
  summary: 'Create and track travel, other direct cost, and general business expense reports through approval and reimbursement.',
  overview: 'The Expenses hub lists your open and historical expense reports with status badges and metrics. From here you start a new report or open an existing one to continue drafting, view details, or enter actuals.',
  howItWorks: [
    'Reports begin as drafts while you build estimates or purchase requests.',
    'Submitting a report sends it to expense reviewers for approval.',
    'Travel reports typically require pre-travel estimates first; after travel you enter actuals with receipts.',
    'General Business and Other Direct Costs often require approval before purchase, then actuals afterward.',
    'Approved reports move toward reimbursement or billing depending on type and company process.',
    'Rejected reports require correction and resubmission.'
  ],
  actions: [
    {
      name: 'New Expense Report',
      description: 'Opens the expense type wizard so you can choose Travel, Other Direct Costs, or General Business.'
    },
    {
      name: 'Open a report row',
      description: 'Navigates to the detail, draft editor, or actuals page for that report based on its current status.'
    },
    {
      name: 'Switch Open / History tabs',
      description: 'Filters between in-progress reports and completed historical reports.'
    }
  ],
  tips: [
    'Use metrics at the top to spot reports that need your attention (drafts, awaiting approval, action required).',
    'Attach receipts when entering actuals — reviewers often need them before approving reimbursement.'
  ],
  related: ['expense-wizard', 'travel-expense', 'expense-review']
};



// WEBPACK FOOTER //
// ./client/help/content/expenses.js